import React, { useState, useEffect } from 'react';
import InnerHeader from './InnerHeader';
import { BASE_URL } from './BaseUrl';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import decryptedUserId from '../Utils/UserID';


const EmailCredential = () => {
  const { empolyeeid } = useParams();

  const [formData, setFormData] = useState({
    Id: null,
    smtpHost: '',
    port: '',
    useCredential: false,
    enableSSL: false
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  // ✅ Fetch data when component mounts
  
    
  useEffect(() => {
     if (empolyeeid) {
       fetchData();
     }
   }, [empolyeeid]);

  const fetchData = async () => {
  try {
    const res = await axios.post(`${BASE_URL}/get_email_credential`, { empolyeeid });
    const data = res.data;

    if (Array.isArray(data) && data.length > 0) {
      const item = data[0];
      setFormData({
        Id: item.Id || null,
        smtpHost: item.SmtpHost || '',
        port: item.Port || '',
        useCredential: !!item.UseCredential,
        enableSSL: !!item.EnableSSL
      });
    } else {
      setFormData({
        Id: null,
        smtpHost: '',
        port: '',
        useCredential: false,
        enableSSL: false
      });
    }
  } catch (err) {
    console.error("Error fetching email credential:", err);
  }
};

  // ✅ Handle form change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // ✅ Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
     const payload = {
  Id: formData.Id,
  Emp_Id: empolyeeid,
  SmtpHost: formData.smtpHost,
  Port: formData.port,
  UseCredential: formData.useCredential,
  EnableSSL: formData.enableSSL,
  CreatedBy: decryptedUserId(),
  UpdatedBy: decryptedUserId()
};


      const res = await axios.post(`${BASE_URL}/save_or_update_email_credential`, payload);

      if (res.data.success) {
        setMessage(res.data.message || 'Saved successfully.');
        // Refresh ID if it was an insert
        if (!formData.Id && res.data.id) {
          setFormData((prev) => ({ ...prev, Id: res.data.id }));
        }
      } else {
        setMessage('Failed to save.');
      }
    } catch (err) {
      console.error("Error saving:", err);
      setMessage('Error saving email credentials.');
    } finally {
      setLoading(false);
    }
  };

  // ✅ Clear form
  const handleClear = () => {
    setFormData({
      Id: null,
      smtpHost: '',
      port: '',
      useCredential: false,
      enableSSL: false
    });
    setMessage('');
  };

  const activeEmpId = (empolyeeid && empolyeeid !== ":empolyeeid" && empolyeeid !== "undefined") ? empolyeeid : ":empolyeeid";

  return (
    <div className="container-fluid page-body-wrapper">
      <InnerHeader />
      <div className="main-panel">
        <div className="content-wrapper">
         <div className="d-flex flex-wrap">
                     {/* Navigation Tabs */}
                     <div className='px-2 mx-2'><Link to={`/employeepersonaldetails/${activeEmpId}`}><h4>Personal Information</h4></Link></div>
                     <div className='px-2 mx-2'><Link to={`/emailcredential/${activeEmpId}`}><h4>Email Credential</h4></Link></div>
                     <div className='px-2 mx-2'><Link to={`/academicqualificationsemp/${activeEmpId}`}><h4>Academic Qualification</h4></Link></div>
                     <div className='px-2 mx-2'><Link to={`/workexperience/${activeEmpId}`}><h4>Work Experience</h4></Link></div>
                     <div className='px-2 mx-2'><Link to={`/leavestructure/${activeEmpId}`}><h4>Leave Structure</h4></Link></div>
                     <div className='px-2 mx-2'><Link to={`/salarystructure/${activeEmpId}`}><h4>Salary Structure</h4></Link></div>
                     <div className='px-2 mx-2'><Link to={`/weeklyoff/${activeEmpId}`}><h4>Weekly Off</h4></Link></div>
                     <div className='px-2 mx-2'><Link to={`/intimesetting/${activeEmpId}`}><h4>Intime Setting</h4></Link></div>
                   </div>

          <form onSubmit={handleSubmit} className="card p-4 mt-3">
            <h4 className="card-title mb-3">Email Credential</h4>

            {message && <div className="alert alert-info">{message}</div>}

            <div className="row">
              <div className="col-lg-4">
                <label>SMTP Host:<span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  name="smtpHost"
                  value={formData.smtpHost}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-lg-4">
                <label>Port:<span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  name="port"
                  value={formData.port}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="row mt-3" style={{ marginLeft: "20px" }}>
              <div className="col-lg-4">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="useCredential"
                    name="useCredential"
                    checked={formData.useCredential}
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="useCredential">
                    Use Credential
                  </label>
                </div>
              </div>

              <div className="col-lg-4" style={{ marginLeft: "20px" }}>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="enableSSL"
                    name="enableSSL"
                    checked={formData.enableSSL}
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="enableSSL">
                    Enable SSL
                  </label>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-lg-4">
                <button type="submit" className="btn btn-primary me-2" disabled={loading}>
                  {loading ? 'Saving...' : 'Submit'}
                </button>
                <button type="button" className="btn btn-secondary" onClick={handleClear}>
                  Clear
                </button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default EmailCredential;
